import styled from 'styled-components'

export const WrapEvents = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  .ant-badge-status {
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    font-size: 12px;
  }
`
